import axios from 'axios'

export const places = axios.create({
  baseURL: 'https://servicodados.ibge.gov.br/api/v1',
})
